import { styled, keyframes } from '@mui/material/styles';

const cursorBlink = keyframes`
  0%, 49% { opacity: 1; }
  50%, 100% { opacity: 0; }
`;

export const BlinkingCursor = styled('span')(({ theme }) => ({
  display: 'inline-block',
  width: '0.6ch',
  height: '1em',
  backgroundColor: theme.palette.primary.main,
  marginLeft: '2px',
  animation: `${cursorBlink} 1s steps(1) infinite`,
}));
